import { h } from 'preact';
import SwatchSelector from './swatch-selector';
import SizeSelector from './size-selector';

const VariantSelector = ({
  currentVariant,
  option,
  setCurrentVariant,
  variants,
  product,
  isQuickView,
  isGiftCard = false,
}) => {
  const optionId = `product-option-${option.name}`;
  const productId = product?.id.split('/Product/')[1];
  const selectedOption = currentVariant.selectedOptions.find(
    (o) => o.name === option.name,
  );

  const handleVariantChange = (e) => {
    const updatedOption = e.target.dataset.optionName;
    const selectedOptions = currentVariant.selectedOptions.map((o) =>
      o.name === updatedOption
        ? { name: updatedOption, value: e.target.value }
        : o,
    );
    const newVariant = variants.find(
      (v) =>
        JSON.stringify(v.selectedOptions) === JSON.stringify(selectedOptions),
    );

    setCurrentVariant(newVariant);
    window.dispatchEvent(new CustomEvent('theme:variant-update', {
      bubbles: true,
      detail: {
        newVariant
      }
    }));
  };
  const isColorOrShadeOption =
    option.name.toLowerCase().includes('color') ||
    option.name.toLowerCase().includes('shade');

  return (
    <div>
      {isColorOrShadeOption ? (
        <SwatchSelector
          option={option}
          optionId={optionId}
          productId={productId}
          handleVariantChange={handleVariantChange}
          selectedOption={selectedOption}
          isQuickView={isQuickView}
          currentVariant={currentVariant}
          product={product}
        />
      ) : (
        <SizeSelector
          option={option}
          optionId={optionId}
          productId={productId}
          handleVariantChange={handleVariantChange}
          selectedOption={selectedOption}
          isQuickView={isQuickView}
          currentVariant={currentVariant}
          product={product}
          isGiftCard={isGiftCard}
        />
      )}
    </div>
  );
};

export default VariantSelector;
